// if you need to add custom parameters to an event,
// replace `eventProperties` with an object
// We're currently using FullStory, and FullStory expects custom
// parameters to follow a specific naming convention.
// see: https://help.fullstory.com/hc/en-us/articles/360020623234#h_01H942JEBG19D6HTGK0Y1V3MZZ
// Example:
// interface MyEvent {
//   eventProperties: {
//     myCustomString_str: string;
//     myCustomInteger_int: number;
//     myCustomFloat_real: number; (decimal/float)
//     myCustomDate_date: Date;
//     myCustomBoolean_bool: boolean;
//   };
//   eventType: 'myEvent';
// }

interface QuickPayValueProperties {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  value_real: number | undefined;
}

interface ClaimFlowEnableBulkQuickPayComplete {
  eventProperties?: never;
  eventType: 'claimFlowEnableBulkQuickPayComplete';
}
interface ClaimFlowEnableBulkQuickPayPrompt {
  eventProperties?: never;
  eventType: 'claimFlowEnableBulkQuickPayPrompt';
}
interface ClaimFlowEnableQuickPayComplete {
  eventProperties?: never;
  eventType: 'claimFlowEnableQuickPayComplete';
}
interface ClaimFlowEnableQuickPayPrompt {
  eventProperties?: never;
  eventType: 'claimFlowEnableQuickPayPrompt';
}
interface DashboardEnableQuickPayComplete {
  eventProperties?: never;
  eventType: 'dashboardEnableQuickPayComplete';
}
interface DashboardEnableQuickPayPrompt {
  eventProperties: QuickPayValueProperties;
  eventType: 'dashboardEnableQuickPayPrompt';
}
interface DashboardEnableQuickPayVisible {
  eventProperties: QuickPayValueProperties;
  eventType: 'dashboardEnableQuickPayVisible';
}
interface DashboardSelectCarrierMoreInfoClicked {
  eventProperties?: never;
  eventType: 'dashboardSelectCarrierMoreInfoClicked';
}
interface DashboardSelectCarrierMoreInfoVisible {
  eventProperties?: never;
  eventType: 'dashboardSelectCarrierMoreInfoVisible';
}
interface DashboardSelectCarrierSelfSelectComplete {
  eventProperties?: never;
  eventType: 'dashboardSelectCarrierSelfSelectComplete';
}
interface DashboardSelectCarrierSelfSelectPrompt {
  eventProperties?: never;
  eventType: 'dashboardSelectCarrierSelfSelectPrompt';
}
interface DashboardSelectCarrierSelfSelectVisible {
  eventProperties?: never;
  eventType: 'dashboardSelectCarrierSelfSelectVisible';
}
interface DashboardSupportLinkClicked {
  eventProperties?: never;
  eventType: 'dashboardSupportLinkClicked';
}
interface DashboardSupportPhoneLinkClicked {
  eventProperties?: never;
  eventType: 'dashboardSupportPhoneLinkClicked';
}
interface FactorLandingPageAllBrokersLinkComplete {
  eventProperties?: never;
  eventType: 'factorLandingPageAllBrokersLinkComplete';
}
interface FactorLandingPageEmailFactorComplete {
  eventProperties?: never;
  eventType: 'factorLandingPageEmailFactorComplete';
}
interface FactorLandingPagePayorNoaEmailComplete {
  eventProperties?: never;
  eventType: 'factorLandingPagePayorNoaEmailComplete';
}
interface FactorLandingPageTermsAndConditionsComplete {
  eventProperties?: never;
  eventType: 'factorLandingPageTermsAndConditionsComplete';
}
interface FactorLandingPageVisible {
  eventProperties?: never;
  eventType: 'factorLandingPageVisible';
}
interface InvoiceShowQuickPayAvailableInvoiceComplete {
  eventProperties?: never;
  eventType: 'invoiceShowQuickPayAvailableInvoiceComplete';
}
interface InvoiceShowQuickPayAvailablePrompt {
  eventProperties: QuickPayValueProperties;
  eventType: 'invoiceShowQuickPayAvailablePrompt';
}
interface InvoiceShowQuickPayAvailableRelationshipComplete {
  eventProperties?: never;
  eventType: 'invoiceShowQuickPayAvailableRelationshipComplete';
}
interface InvoiceShowQuickPayAvailableVisible {
  eventProperties: QuickPayValueProperties;
  eventType: 'invoiceShowQuickPayAvailableVisible';
}
interface InvoicesIndexEnableQuickPayComplete {
  eventProperties?: never;
  eventType: 'invoicesIndexEnableQuickPayComplete';
}
interface InvoicesIndexEnableQuickPayPrompt {
  eventProperties: QuickPayValueProperties;
  eventType: 'invoicesIndexEnableQuickPayPrompt';
}
interface InvoicesIndexEnableQuickPayVisible {
  eventProperties: QuickPayValueProperties;
  eventType: 'invoicesIndexEnableQuickPayVisible';
}
interface InvoicesIndexQuickPayAvailableInvoiceComplete {
  eventProperties?: never;
  eventType: 'invoicesIndexQuickPayAvailableInvoiceComplete';
}
interface InvoicesIndexQuickPayAvailablePrompt {
  eventProperties?: never;
  eventType: 'invoicesIndexQuickPayAvailablePrompt';
}
interface InvoicesIndexQuickPayAvailableRelationshipComplete {
  eventProperties?: never;
  eventType: 'invoicesIndexQuickPayAvailableRelationshipComplete';
}
interface InvoicesIndexQuickPayAvailableVisible {
  eventProperties?: never;
  eventType: 'invoicesIndexQuickPayAvailableVisible';
}
interface NewClaimFlowEnableBulkQuickPayComplete {
  eventProperties?: never;
  eventType: 'newClaimFlowEnableBulkQuickPayComplete';
}
interface NewClaimFlowEnableBulkQuickPayPrompt {
  eventProperties?: never;
  eventType: 'newClaimFlowEnableBulkQuickPayPrompt';
}
interface NoaProcessorRedirectedToOldUI {
  eventProperties?: never;
  eventType: 'noaProcessorRedirectedToOldUI';
}
interface RelationshipShowEnableQuickPayComplete {
  eventProperties?: never;
  eventType: 'relationshipShowEnableQuickPayComplete';
}
interface RelationshipShowEnableQuickPayPrompt {
  eventProperties?: never;
  eventType: 'relationshipShowEnableQuickPayPrompt';
}
interface RelationshipShowEnableQuickPayVisible {
  eventProperties?: never;
  eventType: 'relationshipShowEnableQuickPayVisible';
}
interface RelationshipsIndexEnableQuickPayComplete {
  eventProperties?: never;
  eventType: 'relationshipsIndexEnableQuickPayComplete';
}
interface RelationshipsIndexEnableQuickPayPrompt {
  eventProperties?: never;
  eventType: 'relationshipsIndexEnableQuickPayPrompt';
}
interface RelationshipsIndexEnableQuickPayVisible {
  eventProperties?: never;
  eventType: 'relationshipsIndexEnableQuickPayVisible';
}
interface SelectCarrierLandingPageComplete {
  eventProperties?: never;
  eventType: 'selectCarrierLandingPageComplete';
}
interface SelectCarrierLandingPagePrompt {
  eventProperties?: never;
  eventType: 'selectCarrierLandingPagePrompt';
}
interface SelectCarrierLandingPageVisible {
  eventProperties?: never;
  eventType: 'selectCarrierLandingPageVisible';
}
interface SelectCarrierNavbarLinkClicked {
  eventProperties?: never;
  eventType: 'selectCarrierNavbarLinkClicked';
}
interface SelectCarrierNavbarLinkVisible {
  eventProperties?: never;
  eventType: 'selectCarrierNavbarLinkVisible';
}
interface SubmitPaperworkQuickPayComplete {
  eventProperties?: never;
  eventType: 'submitPaperworkQuickPayComplete';
}
interface SubmitPaperworkQuickPayPrompt {
  eventProperties?: never;
  eventType: 'submitPaperworkQuickPayPrompt';
}
interface SubmitPaperworkSupportLinkClicked {
  eventProperties?: never;
  eventType: 'submitPaperworkSupportLinkClicked';
}
interface SubmitPaperworkSupportPhoneLinkClicked {
  eventProperties?: never;
  eventType: 'submitPaperworkSupportPhoneLinkClicked';
}

export type AnalyticsEvent =
  | ClaimFlowEnableBulkQuickPayComplete
  | ClaimFlowEnableBulkQuickPayPrompt
  | ClaimFlowEnableQuickPayComplete
  | ClaimFlowEnableQuickPayPrompt
  | DashboardEnableQuickPayComplete
  | DashboardEnableQuickPayPrompt
  | DashboardEnableQuickPayVisible
  | DashboardSelectCarrierMoreInfoClicked
  | DashboardSelectCarrierMoreInfoVisible
  | DashboardSelectCarrierSelfSelectComplete
  | DashboardSelectCarrierSelfSelectPrompt
  | DashboardSelectCarrierSelfSelectVisible
  | DashboardSupportLinkClicked
  | DashboardSupportPhoneLinkClicked
  | FactorLandingPageAllBrokersLinkComplete
  | FactorLandingPageEmailFactorComplete
  | FactorLandingPagePayorNoaEmailComplete
  | FactorLandingPageTermsAndConditionsComplete
  | FactorLandingPageVisible
  | InvoiceShowQuickPayAvailableInvoiceComplete
  | InvoiceShowQuickPayAvailablePrompt
  | InvoiceShowQuickPayAvailableRelationshipComplete
  | InvoiceShowQuickPayAvailableVisible
  | InvoicesIndexEnableQuickPayComplete
  | InvoicesIndexEnableQuickPayPrompt
  | InvoicesIndexEnableQuickPayVisible
  | InvoicesIndexQuickPayAvailableInvoiceComplete
  | InvoicesIndexQuickPayAvailablePrompt
  | InvoicesIndexQuickPayAvailableRelationshipComplete
  | InvoicesIndexQuickPayAvailableVisible
  | NewClaimFlowEnableBulkQuickPayComplete
  | NewClaimFlowEnableBulkQuickPayPrompt
  | NoaProcessorRedirectedToOldUI
  | RelationshipShowEnableQuickPayComplete
  | RelationshipShowEnableQuickPayPrompt
  | RelationshipShowEnableQuickPayVisible
  | RelationshipsIndexEnableQuickPayComplete
  | RelationshipsIndexEnableQuickPayPrompt
  | RelationshipsIndexEnableQuickPayVisible
  | SelectCarrierLandingPageComplete
  | SelectCarrierLandingPagePrompt
  | SelectCarrierLandingPageVisible
  | SelectCarrierNavbarLinkClicked
  | SelectCarrierNavbarLinkVisible
  | SubmitPaperworkQuickPayComplete
  | SubmitPaperworkQuickPayPrompt
  | SubmitPaperworkSupportLinkClicked
  | SubmitPaperworkSupportPhoneLinkClicked
;

export type AnalyticsEventKey = AnalyticsEvent['eventType'];

/* eslint-disable @stylistic/max-len */
export const analyticsEventNames: Record<AnalyticsEventKey, string> = {
  claimFlowEnableBulkQuickPayComplete: 'Payee enabled bulk QuickPay from the relationship claim flow',
  claimFlowEnableBulkQuickPayPrompt: 'Payee saw the bulk enable QuickPay dialog in the claim flow',
  claimFlowEnableQuickPayComplete: 'Payee enabled QuickPay from the relationship claim flow',
  claimFlowEnableQuickPayPrompt: 'Payee saw the enable QuickPay dialog in the claim flow',
  dashboardEnableQuickPayComplete: 'Payee enabled QuickPay from the dashboard',
  dashboardEnableQuickPayPrompt: 'Payee clicked the enable QuickPay button on the dashboard',
  dashboardEnableQuickPayVisible: 'Payee saw the enable QuickPay button on the dashboard',
  dashboardSelectCarrierMoreInfoClicked: 'Payee clicked the \'More Info\' Select Carrier button from the dashboard',
  dashboardSelectCarrierMoreInfoVisible: 'Payee saw the \'More Info\' Select Carrier button from the dashboard',
  dashboardSelectCarrierSelfSelectComplete: 'Payee enabled Select Carrier from dashboard',
  dashboardSelectCarrierSelfSelectPrompt: 'Payee clicked the \'Join Now\' Select Carrier button from dashboard',
  dashboardSelectCarrierSelfSelectVisible: 'Payee saw the \'Join Now\' Select Carrier button from dashboard',
  dashboardSupportLinkClicked: 'User clicked the support link on the dashboard',
  dashboardSupportPhoneLinkClicked: 'User opened the support phone dialog on the dashboard',
  factorLandingPageAllBrokersLinkComplete: 'Factored carrier clicked see all brokers link on the factor landing page',
  factorLandingPageEmailFactorComplete: 'Factored carrier clicked the email my factor button on the factor landing page',
  factorLandingPagePayorNoaEmailComplete: 'Factored carrier clicked Payor NOA Email Link on the factor landing page',
  factorLandingPageTermsAndConditionsComplete: 'Factored carrier clicked Terms and Conditions Link on the factor landing page',
  factorLandingPageVisible: 'Factored carrier saw the factor landing page',
  invoiceShowQuickPayAvailableInvoiceComplete: 'Payee enabled QuickPay on an invoice show page',
  invoiceShowQuickPayAvailablePrompt: 'Payee clicked the Enable QuickPay button on an invoice show page',
  invoiceShowQuickPayAvailableRelationshipComplete: 'Payee enabled QuickPay on a relationship from an invoice show page',
  invoiceShowQuickPayAvailableVisible: 'Payee saw the Enable QuickPay button on an invoice show page',
  invoicesIndexEnableQuickPayComplete: 'Payee enabled QuickPay from the invoices index page',
  invoicesIndexEnableQuickPayPrompt: 'Payee clicked the enable QuickPay button on the invoices index page',
  invoicesIndexEnableQuickPayVisible: 'Payee saw the enable QuickPay button on the invoices index page',
  invoicesIndexQuickPayAvailableInvoiceComplete: 'Payee enabled QuickPay on an invoice from an invoice card on the invoices index page',
  invoicesIndexQuickPayAvailablePrompt: 'Payee clicked the QuickPay Available button on an invoice card on the invoices index page',
  invoicesIndexQuickPayAvailableRelationshipComplete: 'Payee enabled QuickPay on a relationship from an invoice card on the invoices index page',
  invoicesIndexQuickPayAvailableVisible: 'Payee saw the QuickPay Available button on an invoice card on the invoices index page',
  newClaimFlowEnableBulkQuickPayComplete: 'Payee enabled bulk QuickPay from the new relationship claim flow',
  newClaimFlowEnableBulkQuickPayPrompt: 'Payee saw the bulk enable QuickPay dialog in the new relationship claim flow',
  noaProcessorRedirectedToOldUI: 'NOA processor was redirected to the legacy UI',
  relationshipShowEnableQuickPayComplete: 'Payee enabled QuickPay from a relationship show page',
  relationshipShowEnableQuickPayPrompt: 'Payee clicked the enable QuickPay button on a relationship show page',
  relationshipShowEnableQuickPayVisible: 'Payee saw the enable QuickPay button on a relationship show page',
  relationshipsIndexEnableQuickPayComplete: 'Payee enabled QuickPay from the relationships index page',
  relationshipsIndexEnableQuickPayPrompt: 'Payee clicked the enable QuickPay button on the relationships index page',
  relationshipsIndexEnableQuickPayVisible: 'Payee saw the enable QuickPay button on the relationships index page',
  selectCarrierLandingPageComplete: 'Payee enabled Select Carrier from select carrier landing page',
  selectCarrierLandingPagePrompt: 'Payee clicked the \'Join Now\' Select Carrier button from landing page',
  selectCarrierLandingPageVisible: 'Payee saw the \'Join Now\' Select Carrier button from landing page',
  selectCarrierNavbarLinkClicked: 'Payee clicked the Select Carrier link on navbar',
  selectCarrierNavbarLinkVisible: 'Payee saw the Select Carrier link on navbar',
  submitPaperworkQuickPayComplete: 'Payee enabled QuickPay from the paperwork success page',
  submitPaperworkQuickPayPrompt: 'Payee was prompted to enable QuickPay from the paperwork success page',
  submitPaperworkSupportLinkClicked: 'User clicked the support link on the Create/Edit Paperwork page',
  submitPaperworkSupportPhoneLinkClicked: 'User opened the support phone dialog on the Create/Edit Paperwork page',
};
/* eslint-enable @stylistic/max-len */

export interface BaseAnalyticsEventProperties {
  displayName: string;
  email: string;
  uid: string;
}
